import { configureStore } from '@reduxjs/toolkit';
import wishesReducer from '../reducers/wishesReducer';

const store = configureStore({
  reducer: {
    wishes: wishesReducer,
  },
});

export default store;